import React, { useState } from 'react';
import { Button } from '@mantine/core';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../../firebase';
import { ensureUserProfile } from '../../services/auth/UserProfileService';

export default function GoogleAuthButton({ label = 'Continue with Google', onSuccess, onError }) {
  const [loading, setLoading] = useState(false);

  const handleGoogle = async () => {
    setLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      const res = await signInWithPopup(auth, provider);
      await ensureUserProfile(res.user);
      onSuccess?.(res.user);
    } catch (e) {
      onError?.(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button fullWidth mb="md" variant="outline" onClick={handleGoogle} loading={loading}>
      {label}
    </Button>
  );
}

